function compilePrivateChannel(name: string): string {
  return `private-${name}`;
}

export function orderChannel(id: number): string {
  return compilePrivateChannel(`order-${id}`);
}

export function orderTrackingChannel(uuid: string): string {
  return `order-tracking-${uuid}`;
}
